import { Component, Inject, OnInit } from '@angular/core';
import { RegistrationRequest } from 'src/models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FacadeService } from 'src/app/services/FacadeService';
import { Store } from '@ngrx/store';
import { login } from '../../store/user/user.action';

@Component({
  selector: 'app-registration-dialog',
  templateUrl: './registration-dialog.component.html',
  styleUrls: ['./registration-dialog.component.less']
})
export class RegistrationDialogComponent implements OnInit {
  info: RegistrationRequest;
  showSpinner: boolean;
  lowerCaseLetters: RegExp;
  upperCaseLetters: RegExp;
  numbers: RegExp;
  specialCharacters: RegExp;
  validEmailAddress: RegExp;
  showError: boolean;
  errorMessage: string;

  constructor(private service: FacadeService, @Inject(MAT_DIALOG_DATA) public data: {navCustomerNo: string}, public dialogRef: MatDialogRef<RegistrationDialogComponent>, private store: Store<{}>  ) { };

  ngOnInit(): void {  
    this.info = new RegistrationRequest();
    this.errorMessage = '';
    this.lowerCaseLetters = /[a-z]/g;
    this.upperCaseLetters = /[A-Z]/g;
    this.numbers = /[0-9]/g;
    this.specialCharacters = /[!@#$%^&*(),.?":{}|<>]/g;
    this.validEmailAddress= /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;

    this.info.navCustomerNo = this.data.navCustomerNo;
  }

  onRegister() { 
    const d = this.info;
    if(!d.firstName || !d.lastName || !d.emailAddress || !this.hasValidPassword || !(d.password == d.confirmPassword) || !d.emailAddress.match(this.validEmailAddress)){
      this.showError = true;
      return;
    }

    this.showError = false;
    this.showSpinner = true;

    
    this.service.productService.Register(this.info).then(data => {   
      const d = data as any; 
      if(d.success){
        const u = {...d.user, isLoggedIn: true}
        this.store.dispatch(login({user: u}));
        this.dialogRef.close(true);
      } else {
        this.errorMessage = d.errorMessage;
        this.showSpinner = false;
      }
   })
  }

  onClose() {    
    this.dialogRef.close();
  }

  get hasLowerCaseLetters() {
    return this.info.password.match(this.lowerCaseLetters);
  }

  get hasUpperCaseLetters() {
    return this.info.password.match(this.upperCaseLetters);
  }

  get hasNumber() {
    return this.info.password.match(this.numbers);
  }

  get hasSpecialCharacter() {
    return this.info.password.match(this.specialCharacters);
  }

  get hasMinimumCharacters() {
    return this.info.password.length >= 8;
  }

  get hasValidEmailAddress() {
    return this.info.emailAddress.match(this.validEmailAddress);
  }

  get hasValidPassword() {
    return this.hasUpperCaseLetters &&
       this.hasLowerCaseLetters && 
       this.hasNumber && 
       this.hasSpecialCharacter && 
       this.hasMinimumCharacters 
  }

}
